module.exports = __webpack_public_path__ + "static/media/Picture21.01476026.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture21.png
// module id = 1553
// module chunks = 0